import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollTop(props) {
  const location = useLocation();

  useEffect(() => {
    let url = window.location.href.split("#")[1];
    if (url && url !== "") {
      let element = document.getElementById(url);
      const navbarHeight = document.getElementById("header").offsetHeight;
      const scrollPosition =
        element.getBoundingClientRect().top + window.scrollY - navbarHeight;
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }, [location]);
  return <>{props.children}</>;
}
